module.exports = __webpack_public_path__ + "static/img/mitrasmall.bc9d826.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mitrasmall.png
// module id = leZ9
// module chunks = 36